export const defaultBlockComponents: Record<string, () => Promise<any>> = {
  emergencyUpdate: () => import("../Homepage/EmergencyUpdate"),
  HeroBannerHomePage: () => import("../Homepage/Hero/Hero"),
  powerNumbers: () => import("../Homepage/Numbers"),
  timeline: () => import("../Homepage/History/History"),
  fAQ: () => import("../Homepage/FAQ/FAQ"),
  trafficUpdates: () => import("../Homepage/TrafficUpdates/TrafficUpdates"),
  bannerModule: () => import("../Homepage/Services"),
  appBanner: () => import("../Homepage/AppBanner"),
  heroBanner: () => import("../Common/Hero"),
  adynamicTitleAndContant: () => import("../Common/DynamicTitle"),
  tabsContent: () => import("../EggedTransportation/TabsContent"),
  paymentMethodsInPublicTransport: () =>
    import("../PaymentApps/PaymentMethods"),
  MultyURLsTitleAndText: () => import("../PaymentApps/MultyURLS"),
  ravKavServiceStation: () =>
    import("../PaymentApps/RavKavServiceStationBlock"),
  informationForPassangers: () =>
    import("../InformationPassengers/InformationBlocks"),
  finePayment: () => import("../Finepayment/FinePayment"),
  logoComponent: () => import("../EggedTransportation/Logo"),
  statistics: () => import("../EggedTransportation/Statistics"),
  buttonComponent: () => import("../EggedTransportation/Button"),
  anchorMenu: () => import("../EggedTransportation/AnchorMenu"),
  tabsContent1: () => import("../EggedTransportation/TabsWithAnchor"),
  mainTitleBlock: () => import("../Content/MainTitle"),
  titleTextAndMediaBlock: () => import("../Content/TitleTextAndMedia"),
  team: () => import("../CorporateGovernance/TeamTabs"),
  employeeRecommendations: () => import("../Career/Recommendations"),
  recommendationsBlock: () => import("../Career/Recommendations"),
  careerFormSection: () => import("../Career/CareerFormSection"),
  BasicBannerModule: () => import("../Career/BasicBannerBlock"),
  jobDisplay: () => import("../Career/JobDisplayWrapper"),
  careerMultyUrl: () => import("../Career/MultyUrl"),
  gallery: () => import("../History/Gallery"),
  contactUs: () => import("../ContactUs/blocks/ContactUsBlock"),
  InquiriesAndRequests: () =>
    import("../ContactUs/blocks/InquiriesAndRequestsBlock"),
  contactUsBoxWithText: () => import("../Finepayment/Contact"),
  operatingHoursContactInfo: () => import("./OperatingHoursContactInfo"),
}
